{
  "cycle.entite.programmes_supprimes": "Programmes supprimés (instantanés conservés)",
  "journalAudit.action.program.attach_proposal_withdrawn": "Proposition de rattachement retirée par le programme",
  "journalAudit.action.program.attach_proposed": "Rattachement d'un projet proposé par le programme",
  "journalAudit.action.program.deleted": "Programme supprimé",
  "journalAudit.action.workspace.created": "Projet créé"
}
